<script setup lang="ts">
import {onUnmounted, type PropType} from "vue";
import Translator from "@/utils/common/Translator";
import TooltipUtils from "@/utils/common/TooltipUtils.ts";
import CloseIcon from "@/components/icons/toastIcons/CloseIcon.vue";
import ClientCache from "@/utils/login/ClientCache.ts";

let props = defineProps({
  messages: {
    required: true,
    type: Object as PropType<namaTypes.NaMaError[]>,
  }
});

onUnmounted(() => {
  TooltipUtils.instance().hideTooltip();
})
</script>

<template>
  <div class="tw-flex tw-flex-col tw-w-full tw-gap-4">
    <div class="tw-flex tw-justify-between tw-items-baseline tw-w-full tw-gap-2">
      <div class="tw-flex tw-flex-wrap tw-flex-row tw-gap-1 tw-overflow-auto tw-max-h-[50vh] tw-w-full">
        <template v-for="(tooltip, index) of messages" :key="index">
          <template v-if="tooltip.message && tooltip.message.englishText">
            <div v-html="Translator.translateNaMaText(tooltip.message)"
                 class="tempo-tooltip-content tw-flex-nowrap tw-w-full tw-overflow-auto tw-max-h-[50vh]">
            </div>
          </template>
        </template>
      </div>
      <q-avatar v-if="ClientCache.isPinTooltip()" square :title="Translator.translateId('close')" @click="$emit('close-toast')"
                class="tw-size-4 tw-cursor-pointer">
        <CloseIcon class="tw-w-[14px] !tw-fill-gray-400  hover:tw-fill-gray-500 tw-divide-opacity-80"/>
      </q-avatar>
    </div>
  </div>
</template>
